import React from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import {
  UiInputAdapter,
  UiSelectAdapter,
  UiDatePickerAdapter,
  UiImageUploaderAdapter,
  UiFieldset,
} from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function LicenseProfileForm({ statesOptions, className, licenseTypes }) {
  return (
    <div className={className}>
      <UiFieldset title="License" isFirst>
        <Columns isMultiline>
          <Column isSize="1/2" className="is-one-third-fullhd">
            <Field
              component={UiSelectAdapter}
              name="licenseTypeId"
              id="licenseTypeId"
              label="License Type"
              required
              options={licenseTypes.map(lt => ({
                value: lt.id,
                label: lt.name,
              }))}
            />
          </Column>
          <Column isSize="1/2" className="is-one-third-fullhd">
            <Field
              component={UiInputAdapter}
              name="licenseNumber"
              id="licenseNumber"
              label="License Number"
              required
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiSelectAdapter}
              name="licenseIssuingState"
              id="licenseIssuingState"
              label="Issuing State"
              required
              options={statesOptions}
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiDatePickerAdapter}
              name="licenseIssuedDate"
              id="licenseIssuedDate"
              label="Issue Date"
              required
              hasIcons="right"
              renderIcons={() => [
                <span className="icon is-small is-right" key="right-icon">
                  <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                </span>,
              ]}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiDatePickerAdapter}
              name="licenseExpirationDate"
              id="licenseExpirationDate"
              label="Expiration Date"
              required
              hasIcons="right"
              renderIcons={() => [
                <span className="icon is-small is-right" key="right-icon">
                  <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                </span>,
              ]}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </Column>
          <Column isSize="full" className="is-paddingless" />
          <Column isSize="1/2">
            <Field
              component={UiImageUploaderAdapter}
              name="licenseImageFront"
              id="licenseImageFront"
              label="License Image (Front)"
              type="file"
              required
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiImageUploaderAdapter}
              name="licenseImageBack"
              id="licenseImageBack"
              label="License Image (Back)"
              type="file"
            />
          </Column>
        </Columns>
      </UiFieldset>
    </div>
  );
}

LicenseProfileForm.defaultProps = {
  className: '',
  licenseTypes: [],
};

LicenseProfileForm.propTypes = {
  statesOptions: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      value: propTypes.string.isRequired,
    })
  ).isRequired,
  className: propTypes.string,
  licenseTypes: propTypes.array,
};
